import { Flex, WrapItem, Box, Stack, LinkBox, LinkOverlay } from '@chakra-ui/layout'
import map from 'lodash/map'
import React, { createElement } from 'react'
import { Tooltip } from '@chakra-ui/react'

import RatioImage from '../RatioImage'

import useImpression from '../../hooks/useImpression'
import useTracker from '../../hooks/useTracker'
import makeLink from '../../helpers/makeLink'
import LinkStats from '../../adminComponents/ProfileEditor/LinkStats'
import Link from '../../components/Link'

const GridItem = ({
  isEditing,
  isPreview,
  src,
  data,
  ratio,
  variant,
  profileId,
  blockId,
  id,
  linkId,
  label,
}) => {
  const ref = useImpression(profileId, blockId, id, linkId)
  const clickTrack = useTracker('click')
  const isExternal = isPreview || data?.mode !== 'internal'
  const imgBox = (
    <LinkBox
      rounded={variant === 'square' ? 'md' : 'full'}
      overflow="hidden"
      boxShadow="md"
      transform="translateZ(0)"
      ref={!isEditing && !isPreview ? ref : undefined}
    >
      <RatioImage
        ratio={ratio}
        src={src}
        isEditing={isEditing}
        isPreview={isPreview}
        compact
      />
      <LinkOverlay
        as={data?.url ? Link : 'p'}
        {...({ [isExternal ? 'href' : 'to']: data?.mode === 'internal' ? data?.url : makeLink(data?.url) })}
        isExternal={isExternal}
        lineHeight="0"
        fontSize="0"
        height="0"
        display="block"
        onClick={() => !isEditing && !isPreview && clickTrack(profileId, blockId, id, linkId)}
      >
        {data?.text}
      </LinkOverlay>
    </LinkBox>
  )
  return label ? (
    <Tooltip label={label}>{imgBox}</Tooltip>
  ) : imgBox
}

const ImageGrid = ({
  items,
  links,
  variant,
  ratio = 1,
  perRow = 4,
  isPreview,
  isEditing,
  id: blockId,
  profileId,
  impressions,
  clicks,
}) => {
  return (
    <Box width="full" as="section">
      <Flex flexWrap="wrap" m="-1" justifyContent="center">
        {map(items, ({ image, linkId, label, ...item }, i) => {
          const child = (
            <GridItem
              src={image}
              data={(isPreview && item['linkId-editor']) || links?.[linkId]}
              isEditing={isEditing}
              isPreview={isPreview}
              ratio={ratio}
              blockId={blockId}
              profileId={profileId}
              linkId={linkId}
              variant={variant}
              label={label}
              id={item.itemId ?? item.id}
            />
          )
          return (
            <Box key={i} width={`${100 / perRow}%`} p="4">
              {isEditing ? (
                <LinkStats
                  linkId={item.linkId}
                  blockId={blockId}
                  profileId={profileId}
                  itemId={item.itemId ?? item.id}
                  impressions={impressions}
                  clicks={clicks}
                  compact
                  direction="column"
                >
                  {child}
                </LinkStats>
              ) : child}
            </Box>
          )
        })}
      </Flex>
    </Box>
  )
}

export default ImageGrid
